<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('moneybag.myWallet')}}</div>
			<div class="top_right" >
				<van-icon name="filter-o" size="25"/>
			</div>
        </div>
		<div class="cards">
		    <div  class="top flex-b-s">
		        <div  class="top-left">
		            <div >{{$t('e.walletaccount')}}</div>
		            <div >{{1*mymoney}}<span >{{$t('e.usdc')}}</span></div>
		        </div>
		        <div  class="top-right"></div>
		    </div>
		    <div  class="middle">
		        <span @click="mtab=1" :class="mtab==1?'mActive':''">{{$t('e.TodaysEarnings')}}</span>
		        <span @click="mtab=2" :class="mtab==2?'mActive':''">{{$t('e.TotalEarnings')}}</span>
		    </div>
		    <div  class="bottom flex-b-c" v-if="tong">
		        <div v-if="mtab==1" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.tfee | parseInt}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.tteamfee | parseInt}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.tfee + tong.tteamfee  | parseInt}}</div>
		            </div>
		        </div>
		        <div v-if="mtab==2" class="bottom-left flex-e-s">
		            <div  class="left-item">
		                <div >{{$t('e.OrderRevenue')}}</div>
		                <div >{{tong.allfee  | parseInt}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('home.team')}}</div>
		                <div >{{tong.allteamfee  | parseInt}}</div>
		            </div>
		            <div  class="left-item">
		                <div >{{$t('e.TotalEarnings')}}</div>
		                <div >{{tong.allfee + tong.allteamfee  | parseInt}}</div>
		            </div>
		        </div>
		    </div>
		</div>
		<!-- <div class="user_yw">
			<div class="all">
                <p >{{$t('trading.balance')}}</p>
			    <p >{{funds}} {{utils_moneyMark()}}</p>
            </div>
		</div>
		<div class="user_zrzc">
			<span class="rechargebtn" @click="$router.push('/invest')">{{$t('moneybag.recharge')}}</span>
			<span class="withdrawbtn" @click="$router.push('/cash')">{{$t('moneybag.withdraw')}}</span>
		</div> -->
		
		<!-- <div class="user_money">
			<div class="money_num">
				<div>
					<p style="font-weight: bold; font-size: 17px; margin: 0px 5px;">
						$ {{funds}} 
					</p>
				</div>
				<div style="font-size: 13px;font-weight: bold;">{{$t('invest.availableBalance')}}</div>
			</div>
			<div class="user_but">
				<div class="but_click but1" @click="$router.push('/cash')">
				{{$t('user.withdraw')}}
				</div>
				<div class="but_click but2" @click="$router.push('/invest')">
				{{$t('moneybag.recharge')}}
				</div>
			</div>
		</div> -->
		
		
        <van-empty :description="$t('moneybag.detailsEmpty')" v-if="listShow" />
        <div v-if="data" class="detail_box">
            <div class="item" v-for="item in data" v-if="item.show==1">
                <div class="de_wrap">
                    <p class="tit">{{item[lang]}}</p>
                    <p class="time">{{item.time}}</p>
                </div>
                <div class="price" :class="item.type =='1'?'':'del'" v-html="item.type =='1'?utils_moneyMark()+' '+parseInt(item.money) : '-'+utils_moneyMark()+' '+parseInt(item.money)"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Fetch from '../../utils/fetch'
    import {
        DropdownMenu,
        DropdownItem,
		Icon
    } from 'vant';

    import { Empty } from 'vant';

    Vue.use(Empty);
    Vue.use(DropdownMenu).use(DropdownItem).use(Icon);

    export default {
        name: "moneybag",
        data() {
            return {
				lang:this.$i18n.locale||"zh_cn",
                data: null,
                list: {},
                account: 0,
                option: [],
				tong:null,
				mtab: 1,
                listShow:false,
                funds: 0,
                frozen: 0,
                mymoney: 0,
                userName:''
            };
        },
        created() {
			this.$parent.footer('user');
        },
        mounted() {
			Fetch('/user/basicinfo').then((r) => {
				this.tong = r.data.tong;
			});
            Fetch('/user/funds').then(r => {
                this.option.push({
                    text: this.$t('moneybag.types'),
                    value: 0
                })
                for (var i in r.data.reason) {
					switch (i) {
					    case "1":
							r.data.reason[i] = this.$t('moneybag.recharge');
					    	break;
					    case "2":
							r.data.reason[i] = this.$t('moneybag.withdraw');
					    	break;
						case "3":
							r.data.reason[i] = this.$t('moneybag.give');
					   	 	break;
						case "4":
							r.data.reason[i] = this.$t('moneybag.signIn');
					    	break;
						case "5":
							r.data.reason[i] = this.$t('moneybag.share');
					    	break;
					    case "6":
							r.data.reason[i] = this.$t('moneybag.purchase');
					    	break;
						case "7":
							r.data.reason[i] = this.$t('moneybag.redPacket');
					   	 	break;
						case "8":
							r.data.reason[i] = this.$t('moneybag.reward');
					    	break;
						case "9":
							r.data.reason[i] = this.$t('moneybag.welfare');
					    	break;
					    case "10":
							r.data.reason[i] = this.$t('moneybag.invite');
					    	break;
						case "11":
						case "12":
							r.data.reason[i] = this.$t('moneybag.income');
					   	 	break;
					    default:
					    	break;
					
					}
                    this.option.push({
                        text: r.data.reason[i],
                        value: i
                    })
                }
                
                this.showError(r.data.list.length);
                this.data = r.data.list;
                this.funds = 1*r.data.money + 1*r.data.wx_bankbz;
                this.mymoney = r.data.mymoney;
                this.frozen = r.data.basemoney;
                this.userName = r.data.username;
				this.listd(1);
            })
        },
        methods: {
			listd(type){
				var dataf = this.data;
				this.data = null;
				if(dataf && dataf.length>0){
					if(type==1){
						for(var i=0;i<dataf.length;i++){
							dataf[i].show = 1;
						}
					}else if(type==2){
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type !=3 && dataf[i].reason_type !=4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}else{
						for(var i=0;i<dataf.length;i++){
							if(dataf[i].reason_type ==3 || dataf[i].reason_type ==4){
								dataf[i].show = 1;
							}else{
								dataf[i].show = 0;
							}
						}
					}
				}
				this.data = dataf;
			},
            chooseType(val) {
                if(val == 0){
                    Fetch('/user/funds').then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }else{
                    Fetch('/user/funds',{
                        reason_id: val
                    }).then(r=>{
                        this.data = r.data.list;
                        this.showError(r.data.list.length);
                    })
                }
            },
            showError(len){
                len == 0 ? this.listShow = true : this.listShow = false
            }
        }
    };
</script>

<style lang="less" scoped>
    .red_top_bg {
		height: 44px;
    }
	.user_yw{
		text-align: center;
		width: 96%;
		margin-top: 20px;
		background: #f1bb0e;
		margin-left: 2%;
		border-radius: 5px 5px 0 0;
		padding: 20px 0;
        display: flex;
		color: #FFF;
        div{
            width: 100%;
        }
		p:nth-child(1){
			font-size: 14px;
			margin-bottom: 20px;
		}
		p:nth-child(2){
			font-size: 14px;
			font-weight: bold;
		}
	}
	.user_zrzc{
		text-align: center;
		width: 96%;
		background: #f1bb0e;
		margin-left: 2%;
		border-radius: 0 0 5px 5px;
		padding: 15px 0;
		display: flex;
		justify-content: space-between;
		text-align: center;
		span{
			width: 40%;
			color: #FFFFFF;
			margin: 0px 20px;
			padding: 12px 10px;
			border-radius: 5px;
			font-size: 14px;
		}
	}

    .detail_box {
        width: 96%;
		margin-left: 2%;
        background: rgba(255, 255, 255, 1);
        border-radius: 6px;
        padding: 0 8px;
        margin-top: 10px;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 8px;
            border-bottom: 1px solid #ECECEC;

            .de_wrap {
                flex: 2;

                .tit {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 20px;
                    font-weight: bold;
                }

                .time {
                    font-size: 12px;
                    color: rgba(0,0,0,.8);
                    line-height: 17px;
                    margin-top: 10px;
                }
            }

            .price {
                flex: 1;
                font-size: 14px;
                line-height: 28px;
                font-weight: bold;
                text-align: right;
                color: #f12211;
                white-space: nowrap;
                &.del {
                    color: #3FAF3E;
                }
            }
        }
    }
	.user_money{
		display: block;
		width: 96%;
		margin-left: 2%;
	    background-color: #fff;
	    border-radius: 10px;
	    padding: 15px;
	    margin-top: 2vh;
	    background: #F1BB0E;
	    background-size: cover;
	    background-position: 50%;
		box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
		.money_num{
		    width: auto;
		    height: 40px;
		    display: flex;
		    align-items: center;
		    justify-content: space-between;
		    font-size: 12px;
		    margin-bottom: 4%;
			>div:first-child {
			    display: flex;
			    align-items: center;
				img{
				    width: 20px;
				    height: 20px;
					display: inline-block;
					overflow: hidden;
					position: relative;
				}
				p{
					font-weight: bold;
					color: #000000e6;
					font-size: 17px;
					margin: 0px 5px;
				}
			}
		}
		.user_but{
		    display: flex;
		    justify-content: space-around;
		    align-items: center;
			.but_click{
			    width: 45%;
			    height: 40px;
			    border-radius: 10px;
			    display: flex;
			    align-items: center;
			    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
			    justify-content: center;
			}
		}
	}
	.cards{
		padding: 16px;
		margin: 16px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		color: #FFF;
		line-height: 20px;
		background: linear-gradient(180deg, #000 0%, #000 100%);
		.flex-e-s {
		    display: flex;
		    justify-content: space-between;
		    align-items: flex-end;
		}
		.top {
		    margin-bottom: 8px;
		}
		
		.top div {
		    font-weight: 700;
			font-size: 15px;
			line-height: 25px;
		}
		
		.top .top-left>div:last-child {
		    word-break: break-all;
		    font-style: italic;
		    font-size:26px;
			    
		}
		.flex-b-c {
		    display: flex;
		    justify-content: space-between;
		    align-items: center;
		}
		.top .top-left>div:last-child span {
		    font-style: normal;
		    font-size: 12px;
			font-weight: 400;
		}
		
		.top .top-right {
		    text-align: center
		}
		
		.top .top-right .group {
		    background-color: var(--84e63418);
		    color: var(--78b8770c);
		    padding: 2px 5px;
		    font-size: 12px;
		    flex-shrink: 0
		}
		
		.top .top-right .group img {
		    margin-right:4px
		}
		
		.top .top-right>div:first-child {
		    margin-bottom: 8px
		}
		
		.top .top-right div {
		    background-color: #fff;
		    padding: 2px 8px;
		    color: #000;
		    border-radius: 8px
		}
		
		.middle {
		    display: flex;
		    align-items: center
		}
		
		.middle span:first-child {
		    margin-right: 10px;
		}
		
		.middle span {
		    display: inline-block;
		    font-size: 12px;
		    padding: 2px 5px;
		    text-align: center;
		    color: #FFF;
		    border: 1px solid #FFF;
		    border-radius: 4px;
			line-height: 20px;
		}
		
		.mActive {
		    background-color: #F1BB0E;
		    color: #000!important;
		    border: none!important
		}
		
		.bottom {
		    margin-top: 8px
		}
		
		.bottom .bottom-left .left-item:not(:last-child) {
		    border-right: 1px solid #F1BB0E
		}
		
		.bottom .bottom-left .left-item:last-child {
		    margin-right: 0
		}
		
		.bottom .bottom-left .left-item {
		    display: flex;
		    flex-direction: column;
		    align-items: start;
		    justify-content: center;
		    margin-right: 10px;
		    padding-right: 10px;
		    font-size: 16px
		}
		
		.bottom .bottom-left .left-item div {
		    color: var(--40ca1237)
		}
		
		.bottom .bottom-left .left-item div:first-child {
		    opacity: .8;
		    font-size: 12px
		}
		
		.bottom .bottom-left .left-item div:last-child {
		    font-weight: 600;
		    word-break: break-all
		}
	}
</style>
